/** News page design tokens — green SaaS theme. */
export const NEWS_COLORS = {
  primary: "#1F7A5A",
  primaryDark: "#176348",
  primarySoft: "#E8F5F0",
  text: "#111827",
  muted: "#6B7280",
  border: "#E5E7EB",
  surface: "#F8FAF9",
  white: "#FFFFFF",
} as const;

/** Matches site Header width + horizontal padding so content aligns. */
export const NEWS_CONTENT_CLASS = "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8";

export const NEWS_PAGE_TITLE =
  "Mohan Nanduri Keynote at KR Bharat Conclave 2026 | Duri News";
export const NEWS_PAGE_DESCRIPTION =
  "Watch Mohan Nanduri's keynote address at KR Bharat Conclave 2026 on redefining Indian mobility, live Vahan & DigiLocker trust, and sustainable carpooling under Vikasit Bharat 2047.";
